/* LollyDoll · visionneuse plein écran, une image à la fois */
(function () {
  var lb = document.querySelector('[data-ll-lb]');
  if (!lb) return;

  var slides = Array.prototype.slice.call(lb.querySelectorAll('[data-ll-slide]'));
  var index = 0;
  var ouvreur = null;

  function afficher(i) {
    if (!slides.length) return;
    index = (i + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('is-on', k === index); });
  }

  function ouvrir(i) {
    ouvreur = document.activeElement;
    lb.hidden = false;
    lb.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ll-lb-open');
    afficher(i || 0);
    requestAnimationFrame(function () { lb.classList.add('is-on'); });
    var close = lb.querySelector('[data-ll-close]');
    if (close) close.focus();
  }

  function fermer() {
    lb.classList.remove('is-on');
    lb.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ll-lb-open');
    setTimeout(function () { lb.hidden = true; }, 220);
    if (ouvreur && ouvreur.focus) ouvreur.focus();
  }

  lb.querySelector('[data-ll-prev]').addEventListener('click', function () { afficher(index - 1); });
  lb.querySelector('[data-ll-next]').addEventListener('click', function () { afficher(index + 1); });
  lb.querySelector('[data-ll-close]').addEventListener('click', fermer);
  lb.addEventListener('click', function (e) {
    if (e.target === lb || e.target.classList.contains('ll-lb__scene')) fermer();
  });

  document.addEventListener('keydown', function (e) {
    if (lb.hidden) return;
    if (e.key === 'Escape') fermer();
    else if (e.key === 'ArrowLeft') afficher(index - 1);
    else if (e.key === 'ArrowRight') afficher(index + 1);
  });

  // glissement au doigt
  var x0 = null;
  lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  lb.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var d = e.changedTouches[0].clientX - x0;
    if (Math.abs(d) > 45) afficher(index + (d < 0 ? 1 : -1));
    x0 = null;
  }, { passive: true });

  // on remplace l'ouverture native de Dawn
  function positionActuelle() {
    var actif = document.querySelector('media-gallery .product__media-item.is-active');
    if (!actif) return 0;
    var tous = Array.prototype.slice.call(document.querySelectorAll('media-gallery .product__media-item'));
    var i = tous.indexOf(actif);
    return i < 0 ? 0 : i;
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    // on n'intercepte que l'ouverture du zoom, jamais les vignettes
    if (e.target.closest('.thumbnail-list, .thumbnail')) return;
    var cible = e.target.closest(
      '.product__modal-opener, .product__media-zoom-lightbox, [data-ll-open-lb], .product__media-icon'
    );
    if (!cible) return;
    e.preventDefault();
    e.stopPropagation();
    ouvrir(positionActuelle());
  }, true);
})();